const Footer = () => (
  <footer className="footer text-center footer-bottom">
    All Rights Reserved by Enjoyworks. Designed and Developed by PHP team.
  </footer>
)

export default Footer
